import React from 'react';
import { Table, TableContainer, Typography } from '@material-ui/core';
import { ApolloError } from '@apollo/client';

import { IOrder } from 'pages/orderHistory/hooks/useOrders';
import { OrdersTableHead } from './OrdersTableHead';
import { OrdersTableBody } from './OrdersTableBody';

interface IOrdersTableProps {
  orders: IOrder[];
  error: ApolloError | undefined;
}

export const OrdersTable = ({ orders, error }: IOrdersTableProps) => {
  if (error) {
    throw new Error('Ocorreu um problema ao carregar as informações da tabela.');
  }

  return (
    <>
      {orders && orders.length > 0 ? (
        <TableContainer>
          <Table>
            <OrdersTableHead />
            <OrdersTableBody orders={orders} />
          </Table>
        </TableContainer>
      ) : (
        <Typography>Você não possui pedidos dentro dos filtros selecionados</Typography>
      )}
    </>
  );
};
